import { formatDateTime, formatRelative } from '@/lib/format';

/** "5 minutes ago", with the full en-AU date and time on hover and for screen readers. */
export function RelativeTime({ iso, className }: { iso: string; className?: string }) {
  return (
    <time dateTime={iso} title={formatDateTime(iso)} className={className}>
      {formatRelative(iso)}
    </time>
  );
}
